import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

/**
 * 404 Not Found page
 * Shows when user navigates to non-existent route
 */
const NotFound = () => {
  return (
    <main id="main-content" className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center space-y-8">
        <div className="space-y-4">
          <h1 className="text-[clamp(72px,15vw,180px)] font-bold tracking-[-0.02em] text-accent leading-none">
            404
          </h1>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
            Page not found
          </h2>
          <p className="text-lg text-muted-foreground max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
          <Button 
            asChild 
            size="lg"
            className="group bg-accent hover:bg-accent-strong text-accent-foreground font-medium"
          >
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Go home
            </Link>
          </Button>
          
          <Button 
            asChild 
            variant="outline" 
            size="lg"
            className="font-medium"
          >
            <button onClick={() => window.history.back()}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go back
            </button>
          </Button>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
